export default __webpack_public_path__ + "static/Group 60-c98b6c6d40a09bf59c0b113e4ddce9ef.png";